import isValid from 'date-fns/isValid';
import {
    addMinutes,
    format,
} from 'date-fns';

export const applicationDateFormat = 'dd/MM/yyyy';
export const applicationTimeFormat = 'hh:mm aa';

export const isValidDate = (date: unknown): date is Date => isValid(date);

export const formatDateForDisplay = (date: Date | number | null) => {
    if (isValidDate(date)) {
        return format(date as Date | number, applicationDateFormat);
    }
    return '';
};

export const formatDateTimeForDisplay = (date: Date | number | null) => {
    if (isValidDate(date)) {
        return format(date as Date | number, `${applicationDateFormat} ${applicationTimeFormat}`);
    }
    return '';
};

export const addOrSubtractMinutes = (date: Date, n: number) => addMinutes(date, n);

export const formatDate = (dateString: Date | number, formatString: string) => (
    format(dateString, formatString)
);
